export default __webpack_public_path__ + "static/media/video.4bd40f3a.svg";